import { lineLabelCenter, nameLabelBox } from './mapLineLabel'
import { PAGE_PX_PER_MM } from './printLayout'
import type { GeoLine } from './types'

/** Font size supported by the existing worker; replaced with the shared paper law later. */
export const LEGACY_PRINT_LABEL_MM = 4

/**
 * Where a line's name is centred on paper, by mobile's placement rule.
 * `labelMm` is the printed font size — the print panel's label slider — so the
 * offset that clears the line matches the label actually printed.
 */
export function printLineNameAnchor(
  line: GeoLine,
  background: boolean,
  scale: number,
  latitude: number,
  labelMm: number = LEGACY_PRINT_LABEL_MM,
) {
  const sizeMm = labelMm > 0 ? labelMm : LEGACY_PRINT_LABEL_MM
  const box = nameLabelBox(
    line.name ?? '',
    sizeMm * PAGE_PX_PER_MM,
    background,
  )
  const mmPerProjectedM = (1000 * Math.cos((latitude * Math.PI) / 180)) / scale
  return lineLabelCenter(
    line.points,
    line.width,
    { w: box.w / PAGE_PX_PER_MM, h: box.h / PAGE_PX_PER_MM },
    mmPerProjectedM,
  )
}
